<template>
  <v-dialog v-model="dialog" :retain-focus="false" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="categoryForm" v-model="isFormValid">
            <v-layout wrap>
              <v-flex xs12>
                <h3 class="delimiter_text">General info</h3>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.trim="catData.catName"
                  label="Category name"
                  :rules="requiredRule"
                  :counter="15"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model.trim="catData.catDesc"
                  label="Category description"
                  :rules="requiredRule"
                  :counter="255"
                  required
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.trim="catData.catType"
                  label="Category type"
                  :rules="requiredRule"
                  :counter="100"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close">Cancel</v-btn>
        <v-btn
          :disabled="!isFormValid"
          color="secondary"
          text
          @click="actionName"
          >Add</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validation } from "../../mixins/validationMixin";
export default {
  name: "newCategoryForm",
  mixins: [validation],
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    index: {
      type: [Number, Boolean, String],
      default: () => -1,
      required: true
    }
  },
  data() {
    return {
      isFormValid: true,
      catData: {
        catName: "",
        catDesc: "",
        catType: "",
        updateSource: "newCategoryForm"
      },
      defaultData: {
        catName: "",
        catDesc: "",
        catType: "",
        updateSource: "newCategoryForm"
      }
    };
  },
  computed: {
    formTitle() {
      return this.index > 0 ? "Edit category" : "New category";
    },
    actionName() {
      return this.index > 0 ? this.editCategory : this.addCategory;
    }
  },
  methods: {
    close() {
      this.$emit("close-form");
      this.catData = Object.assign({}, this.defaultData);
    },
    editCategory() {},
    addCategory() {
      this.$emit("set-loading", true);
      this.$store
        .dispatch("categoryMerge", this.catData)
        .then(() => {
          this.$emit("set-loading", false);
          this.$toast.success(
            `Category ${this.catData.catName} has been added`
          );
          this.close();
        })
        .catch(error => {
          console.error(error);
          this.$emit("set-loading", false);
          this.close();
        });
    }
  }
};
</script>
